<div class="modal fade full" id='modalTokens' tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-sm">
    <div class="modal-content">

      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Administração de chaves </h5>
        <img data-bs-dismiss="modal" class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg">        
      </div>

      <div class="mb-4">
        <div class="p-3 pe-4 ps-4 row justify-content-between">
            <button class="btn btn-secondary" (click)="copyToClipboard()"><i class="fa fa-share me-1"></i> Enviar o link de Acesso ao portal da transportadora</button>
            <a type="button" class="btn btn-secondary"  id="btnDownloadAppTransp" [href]="urlDownload"><i class="fa fa-android me-1" ></i> Download do aplicativo</a>
        </div>
        <span class="text-danger ms-3 sub-titutlo">A partir de 01/10/2024 a administração de tokens deve ser acessada exclusivamente pelo <a class="text-underline btn-hover" (click)="abrirMapaTransportadora()">Mapa da Transportadora.</a></span>
        <hr>
        <div class="modal-body">

          <div id="loading" *ngIf="loading">
            <img src="/assets/img/loading.gif" alt="gif loading" class="me-3" width="20"> <span>Carregando
              informações</span>
          </div>

          <div class="d-flex flex-row bd-highlight mb-3 justify-content-between align-items-end">
            <div>
              <div class="col-md-12 ">
                <div class="form-row align-items-end">
                  <div class="form-group col-md-4">
                    <label class="titulo">Nova chave</label>
                    <input type="text" class="form-control" [(ngModel)]="inputDescricao"
                      placeholder="Descrição da chave">
                  </div>

                  <div class="form-group">
                      <div class="custom-control custom-switch mb-1">
                        <input type="checkbox" class="custom-control-input cursor-pointer" id="switchSemValidade"
                          [(ngModel)]="comValidade">
                        <label class="custom-control-label cursor-pointer titulo" for="switchSemValidade">
                          {{ comValidade ? 'Com validade' : 'Sem validade' }}
                        </label>
                      </div>
                    
                      <div >
                        <label class="titulo"></label>
                        <input type="date" class="form-control" [(ngModel)]="validade" placeholder="Data de validade" [disabled]="!comValidade">
                      </div>
                  </div>

                  <div class="form-group col-md-3">
                    <label class="titulo">Transportadora</label>
                    <select class="form-control" [(ngModel)]="motorTranspSelecionado" >
                      <option 
                      *ngFor="let transportadora of transportadoras"  [ngValue]="transportadora" class="option-motorista">
                        {{transportadora.CdMotor}}
                      </option>
                      <option [ngValue]="null" >
                    </select>                                       
                  </div>

                  <div class="form-group col-md-1">
                    <div class="custom-control custom-switch mb-2">
                      <input type="checkbox" class="custom-control-input cursor-pointer" id="switchAtivo"
                        [(ngModel)]="switchAtivo">
                      <label class="custom-control-label cursor-pointer" for="switchAtivo">Ativo</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
            </div>
            <div class="mb-4">
              <button class="btn btn-primary" (click)="gerarChave()" [disabled]="inputDescricao.length == 0 || motorTranspSelecionado == null"> <i
                  class="fa fa-check me-1"></i> Gerar chave</button>
            </div>
          </div>



          <div class="row">
            <div class="col-md-12">
              <p class="mb-3 titulo ">Chaves cadastradas ({{ tokens.length }})</p>
              <div class="table-responsive shadow table-border-radius">
                <table class="table table-sm mb-custom">
                  <thead>
                    <tr>
                      <th class="w-drop"></th>
                      <th>
                        <label class="mt-3 titulo">Descrição</label>
                      </th>
                      <th class="w-validade">
                        <label class="titulo">Validade</label>
                      </th>
                      <th class="w-validade">
                        <label class="titulo">Status</label>
                      </th>
                      <th class=" w-nome-transp">
                        <label class="titulo">Transportadora</label>

                      </th>
                      <th>
                        <label class="titulo">Token</label>
                      </th>
                      <th class="w-drop"></th>
                      <th class="w-drop"></th>
                    </tr>

                  </thead>
                  <tbody>

                    <tr *ngFor="let dadosChaveAcesso of tokens">
                      <td class="w-drop">
                        <div class="dropdown hover-btn">
                          <i class="fa fa-ellipsis-v" data-bs-toggle="dropdown"></i>
                          <div class="dropdown-menu shadow">
                            <button class="dropdown-item" (click)="gerarPDFQRCode(dadosChaveAcesso)"><i
                                class="fa fa-qrcode me-1"></i> Gerar QR code de acesso</button>
                            <button class="dropdown-item" (click)="editarChave(dadosChaveAcesso)"><i
                                class="fa fa-edit me-1"></i>Editar</button>
                          </div>
                        </div>
                      </td>
                      <td class="sub-titutlo" *ngIf="!dadosChaveAcesso.modoEdicao; else ModoEdicaoInput">{{
                        dadosChaveAcesso.descricao }}</td>
                      <ng-template #ModoEdicaoInput>
                        <td style="width: 228px;">
                          <input type="text" class="form-control" [(ngModel)]="inputDescricaoEdicao">
                        </td>
                      </ng-template>

                      <td class="w-validade" *ngIf="!dadosChaveAcesso.modoEdicao; else modoEdicaoValidade">
                        {{ dadosChaveAcesso.validade | date: 'dd/MM/yyyy' }}
                      </td>

                      <ng-template #modoEdicaoValidade>
                        <td style="width: 184px;padding: 4px 20px;">
                          <input type="date" class="form-control" placeholder="Data de validade"
                            [(ngModel)]="validadeEdicao">
                        </td>
                      </ng-template>

                      <ng-template #modoEdicaoTransportadora>
                        <div class="form-group col-md-4" placeholder="Transportadora">
                          <button class="btn btn-primary bt-outline dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            {{ "Transportadora" }}
                          </button>
                          <div class="form-group col-md-4 dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <button class="dropdown-item">X</button>
                          </div>
                        </div>
                      </ng-template>




                      <td class="w-validade" *ngIf="!dadosChaveAcesso.modoEdicao; else modoEdicao">
                        <span class="status-ativo sub-titutlo" *ngIf="dadosChaveAcesso.ativo; else inativo"> <i
                            class="fa fa-check-circle"></i> Ativo</span>
                        <ng-template #inativo>
                          <span class="status-inativo sub-titutlo"> <i class="fa fa-minus-circle"></i> Inativo</span>
                        </ng-template>
                      </td>
                      <ng-template #modoEdicao>
                        <td class="w-validade">
                          <div class="custom-control custom-switch mb-2">
                            <input type="checkbox" class="custom-control-input cursor-pointer" id="switchAtivoEdicao"
                              [(ngModel)]="switchAtivoEdicao">
                            <label class="custom-control-label cursor-pointer" for="switchAtivoEdicao">Ativo</label>
                          </div>
                        </td>
                      </ng-template>

                      <td class="sub-titutlo w-nome-transp">{{ dadosChaveAcesso.cdMotor}}</td>
                      <td class="sub-titutlo">{{ dadosChaveAcesso.token}}</td>                     

                      <td class="w-drop">
                        <a (click)="fecharEdicao()" class="cursor-pointer" title="voltar"> <i class="fa fa-arrow-left" style="color: #6c757d"
                            [hidden]="!dadosChaveAcesso.modoEdicao"></i> </a>
                      </td>

                      <td class="w-drop">
                        <a (click)="gravarEdicao(dadosChaveAcesso)" class="cursor-pointer" title="Confirmar edição"> <i
                            class="fa fa-check" style="color: green" [hidden]="!dadosChaveAcesso.modoEdicao"></i> </a>
                      </td>
                    </tr>

                  </tbody>

                </table>
              </div>
            </div>
          </div>


        </div>

      </div>
    </div>
  </div>